module.exports = __webpack_public_path__ + "img/analytics-logo.4c11d549.png";